import Checkbox from "./main";

export default Checkbox;
